import { createFileRoute } from '@tanstack/react-router'
import { PaymentDetailPage } from '@/features/payments/payment-detail-page'
import { requirePermission } from '@/lib/route-guards'

/** Recibo de un pago con su aplicación y la reversa. */
export const Route = createFileRoute('/_app/payments/$paymentId')({
  beforeLoad: requirePermission('payments:read'),
  component: PaymentDetailRoute,
})

function PaymentDetailRoute() {
  const { paymentId } = Route.useParams()
  return <PaymentDetailPage paymentId={paymentId} />
}
